import { createFileRoute, redirect } from '@tanstack/react-router';

import { hasDistriAccess, ROLES } from '@data-access';

export const Route = createFileRoute('/_app/_admin')({
  beforeLoad(ctx) {
    if (
      !ctx.context.auth.user?.user_access ||
      !hasDistriAccess(ctx.context.auth.user?.user_access)
    ) {
      redirect({
        to: '/map',
      });
    }
  },
});
